module.exports = __webpack_public_path__ + "img/en.31b2610c.svg";